import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import EditorialCard from "@/components/EditorialCard";
import SectionHeader from "@/components/SectionHeader";
import api from "@/lib/api";

const ArticlesListPage = () => {
  const [items, setItems] = useState([]);
  const [params, setParams] = useSearchParams();
  const initialCat = params.get("category") || "All";
  const [category, setCategory] = useState(initialCat);

  useEffect(() => { (async () => setItems(await api.articles()))(); }, []);

  const categories = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = category === "All" ? items : items.filter((i) => i.category === category);

  const onSelect = (c) => {
    setCategory(c);
    if (c === "All") setParams({});
    else setParams({ category: c });
  };

  return (
    <div data-testid="articles-list-page">
      <section className="pt-16 md:pt-24 pb-10 max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeader
          overline="Long-Form"
          title="Articles worth the reading time."
          lede="Original, considered writing on business, leadership, technology and the operators shaping global industry."
        />
      </section>

      <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-10">
        <div className="flex flex-wrap gap-2" data-testid="articles-category-filter">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => onSelect(c)}
              data-testid={`articles-filter-${c.toLowerCase().replace(/\s+/g,"-")}`}
              className={`px-4 py-2 text-[11px] font-mono-editorial uppercase tracking-[0.22em] border transition-all rounded-full ${
                category === c ? "bg-ink text-paper border-ink" : "text-ink-soft border-ink-line hover:border-ink hover:text-ink"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="articles-grid">
          {filtered.map((a, i) => (
            <EditorialCard
              key={a.id}
              number={String(i + 1).padStart(2, "0")}
              overline={a.category}
              title={a.title}
              excerpt={a.excerpt}
              image={a.image}
              meta={`${a.author} · ${a.read_time}`}
              href={`/articles/${a.slug}`}
              testId={`article-card-${a.slug}`}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default ArticlesListPage;
